import React from 'react';
import { ChevronRight } from 'lucide-react';
import { STEPS } from './onboardingSteps';

interface OnboardingStepChromeProps {
  filledSegmentCount: number;
  /** Progress bar segments; defaults to current onboarding checklist length. */
  segmentCount?: number;
  title: string;
  subtitle: string;
  onBack: () => void;
}

const OnboardingStepChrome: React.FC<OnboardingStepChromeProps> = ({
  filledSegmentCount,
  segmentCount = STEPS.length,
  title,
  subtitle,
  onBack,
}) => (
  <>
    <div className="flex gap-1 px-4 pt-4">
      {Array.from({ length: segmentCount }).map((_, i) => (
        <div
          key={i}
          className="h-1 flex-1 rounded-full"
          style={{ backgroundColor: i < filledSegmentCount ? '#172F27' : '#E5E7EB' }}
        />
      ))}
    </div>

    <div className="flex items-center gap-3 px-4 pt-3 pb-3 border-b border-gray-100">
      <button
        type="button"
        onClick={onBack}
        className="p-2 rounded-lg"
        style={{ backgroundColor: 'transparent' }}
      >
        <ChevronRight size={20} style={{ color: '#6B7280', transform: 'rotate(180deg)' }} />
      </button>
      <div>
        <h2 className="text-lg font-semibold leading-tight" style={{ color: '#111827' }}>
          {title}
        </h2>
        <p className="text-xs" style={{ color: '#6B7280' }}>
          {subtitle}
        </p>
      </div>
    </div>
  </>
);

export default OnboardingStepChrome;
